<template>
  <div class="home">
    <div class="top">
      <div class="main-title"><span>碳排放计算器</span></div>
    </div>
    <div class="main-body">
      <div class="sub-title-img"><span>数据填报</span></div>
      <div>
        <p class="body-title">基本信息</p>
        <div class="popup-group">
          <div>
            <van-cell title="行业" :value="from.industry" :is-link="isLinkIndustry" @click="showIndustry"
                      class="popup-style"/>
            <van-popup v-model="isShowIndustry" position="bottom" :style="{ height: '40%' }">
              <van-area title="行业" :area-list="industryList" @confirm="confirmIndustry" @cancel="cancel"
                        columns-num="2"/>
            </van-popup>
          </div>
          <div>
            <van-cell title="标准" :value="from.addr" :is-link="isLinkAddr" @click="showAddr" class="popup-style"/>
            <van-popup v-model="isShowAddr" position="bottom" :style="{ height: '40%' }">
              <van-area title="标准" :area-list="areaList" @confirm="confirmAddr" @cancel="cancel" columns-num="1"/>
            </van-popup>
          </div>
          <van-field class="input"
                     v-model="annualOutputValue.value"
                     :label="annualOutputValue.label"
                     :placeholder="annualOutputValue.placeholder"
                     type="number"/>
        </div>
      </div>
      <ul v-for="(title,index) in paramsInputList[industryNo].title" :key="index">
        <li class="body-title">{{ title }}</li>
        <van-cell-group class="input-group">
          <van-field class="input"
                     v-for="(item,key) in paramsInputList[industryNo].input[index]"
                     :key="key"
                     v-model="item.value"
                     :label="item.label"
                     :placeholder="item.placeholder"
                     type="number"/>
        </van-cell-group>
      </ul>
      <div class="btn-block">
        <button class="btn-next" @click="next">下一步</button>
      </div>
      <div class="sub-title-img" v-show="isShowVideo"><span>操作指引</span></div>
      <div class="input_video" v-show="isShowVideo">
        <video-player  class="video-player vjs-custom-skin"
                       ref="videoPlayer"
                       :playsinline="true"
                       :options="playerOptions"
        ></video-player>
      </div>
    </div>
  </div>
</template>

<script>
import { areaList } from '../assets/js/areaList'
import { industry } from '../assets/js/industry'
import { paramsInputList } from '../assets/js/paramsInputList'
import { Toast } from 'vant'
import { simpleMultiply, addValue } from '../assets/js/calculate'

export default {
  name: 'Home',
  data () {
    return {
      isShowIndustry: false,
      isShowAddr: false,
      isLinkIndustry: true,
      isLinkAddr: true,
      isShowVideo: true,
      industryNo: 0,
      bigIndustryNo: 0,
      areaList: areaList,
      industryList: industry,
      paramsInputList: paramsInputList,
      from: {
        industry: '请选择行业',
        addr: '请选择标准'
      },
      annualOutputValue: {
        value: '',
        label: '年产值',
        placeholder: '单位：万元'
      },
      // 视频播放
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选择的播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '829:1792', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: 'video/mp4',
          src: require('../assets/video/IntroduceVideo.mp4')// url地址
        }],
        poster: '', // 你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 全屏按钮
        }
      }
    }
  },
  methods: {
    next () {
      // 计算一个行业每个小模块的碳排放总量，value为用户输入值，factor为需要乘上的碳排放因子或者计算公式
      // 存入resList中传给下一个界面
      // resList中存的是每个阶段的碳排放总量和环形图的数据 [[value,name],[value,name],...]
      // barChartList存放的是柱形图的数据[[value,label],[value,label],...]
      const resList = []
      const barChartList = []
      const annualProValue = this.annualOutputValue.value
      let oneStageSum = 0
      // 获取paramsInputList中的input
      let input = this.paramsInputList[this.industryNo].input
      // 环形图标题名称
      let pieChartTitle = this.paramsInputList[this.industryNo].pieChartTitle
      let oneBarChartList = []
      switch (this.industryNo) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 8:
        case 12:
        case 13:
        case 15:
        case 19:
        case 21:
          // 这个for循环用的算法是每个参数的value和factor直接相乘得出每个阶段的碳排放总量
          for (let i = 0; i < input.length; i++) {
            for (let j = 0; j < input[i].length; j++) {
              if (input[i][j].value !== '') {
                oneStageSum += input[i][j].value * input[i][j].factor
              }
              let val = {
                value: input[i][j].value * input[i][j].factor,
                label: input[i][j].label
              }
              oneBarChartList.push(val)
            }
            // 把每个阶段的值乘以对应的因子或者计算公式放到List中传给第二个页面，总量计算在第二个页面
            let pieChartItem = {
              value: oneStageSum,
              name: pieChartTitle[i]
            }
            resList.push(pieChartItem)
            barChartList.push(oneBarChartList)
            oneStageSum = 0
            oneBarChartList = []
          }
          break
        case 5:
          for (let i = 0; i < input.length; i++) {
            if (i === 1) {
              // 回收利用阶段计算
              oneStageSum = (input[1][0].value * input[1][1].value + input[1][2].value * input[1][3].value) * 19.7 * 0.01
              addValue(oneStageSum, pieChartTitle[1], resList, barChartList)
              oneStageSum = 0
            } else {
              simpleMultiply(this.paramsInputList[this.industryNo], i, i, resList, barChartList)
            }
          }
          break
        case 6:
          break
        case 7: {
          // 燃料阶段计算
          simpleMultiply(this.paramsInputList[this.industryNo], 0, 0, resList, barChartList)
          // HCFC-22生产过程HFC-23排放
          let firstProcess = input[1][0].value * input[1][2].value * input[1][3].value - input[1][4].value -
            input[1][1].value * (input[1][5].value - input[1][6].value)
          oneBarChartList = []
          let val = {
            value: firstProcess,
            label: 'HFC-23排放'
          }
          oneBarChartList.push(val)
          // 被销毁的HFC-23转化成的CO2排放
          let secondProcess = input[2][0].value * input[2][0].factor
          val = {
            value: secondProcess,
            label: input[2][0].label
          }
          oneBarChartList.push(val)
          // HFCs/PFCs/SF6生产过程副产物及逃逸排放
          let thirdProcess = input[3][0].value * input[3][1].value
          val = {
            value: thirdProcess,
            label: '副产物及逃逸排放'
          }
          oneBarChartList.push(val)
          let pieChartItem = {
            value: firstProcess + secondProcess + thirdProcess,
            name: pieChartTitle[1]
          }
          resList.push(pieChartItem)
          barChartList.push(oneBarChartList)
          // 外购电力
          simpleMultiply(this.paramsInputList[this.industryNo], 4, 2, resList, barChartList)
          // 外购热力
          simpleMultiply(this.paramsInputList[this.industryNo], 5, 3, resList, barChartList)
          break
        }
        case 9:
          for (let i = 0; i < input.length; i++) {
            if (i === 2) {
              // 原料分解产生的碳排放
              oneStageSum = (input[2][0].value * 1 + input[2][1].value * 1 + input[2][2].value * 1) *
                ((input[2][3].value - input[2][4].value) * 44 / 56 + (input[2][5].value - input[2][6].value) * 44 / 40) * 0.01
              addValue(oneStageSum, pieChartTitle[2], resList, barChartList)
              oneStageSum = 0
            } else {
              // i=0 燃料阶段计算 i=1 替代燃料或废弃物中非生物质碳的燃烧排放 i=3 生料中非燃料碳煅烧的排放 i=4 外购电力 i=5 外购热力
              simpleMultiply(this.paramsInputList[this.industryNo], i, i, resList, barChartList)
            }
          }
          break
        case 10:
          break
        case 11:
          break
        case 14:
          for (let i = 0; i < input.length; i++) {
            if (i === 2) {
              oneStageSum = (input[2][0].value * input[2][0].factor + input[2][1].value * input[2][1].factor +
                input[2][2].value * input[2][2].factor + input[2][3].value * input[2][3].factor)
              addValue(oneStageSum, pieChartTitle[2], resList, barChartList)
              oneStageSum = 0
            } else {
              simpleMultiply(this.paramsInputList[this.industryNo], i, i, resList, barChartList)
            }
          }
          break
        case 17:
          for (let i = 0; i < input.length; i++) {
            // 生产过程
            if (i === 1) {
              oneStageSum = input[1][0].value * 0.996 * (0.349 * 0.44 + input[1][1].value) * 44 / 84
              addValue(oneStageSum, pieChartTitle[1], resList, barChartList)
              oneStageSum = 0
            } else {
              simpleMultiply(this.paramsInputList[this.industryNo], i, i, resList, barChartList)
            }
          }
          break
        case 18:
          for (let i = 0; i < input.length; i++) {
            // 生产过程
            if (i === 1) {
              oneStageSum = input[1][0].value * input[1][1].value * input[1][2].value * 44 / 12
              addValue(oneStageSum, pieChartTitle[1], resList, barChartList)
              oneStageSum = 0
            } else {
              simpleMultiply(this.paramsInputList[this.industryNo], i, i, resList, barChartList)
            }
          }
          break
        case 20: {
          let factor = 0
          if (input[2][0].value === 1) {
            factor = 0.25 * 0.7
          } else if (input[2][0].value === 2) {
            factor = 0.25 * 0.3
          } else {
            factor = 0.25 * 0.5
          }
          for (let i = 0; i < input.length; i++) {
            if (i === 2) {
              oneStageSum = (input[2][1].value * input[2][2].value - input[2][3].value) * factor -
                input[2][4].value
              addValue(oneStageSum, pieChartTitle[2], resList, barChartList)
              oneStageSum = 0
            } else {
              simpleMultiply(this.paramsInputList[this.industryNo], i, i, resList, barChartList)
            }
          }
          break
        }
        case 22:
          for (let i = 0; i < input.length; i++) {
            if (i === 1) {
              let tempSum = 0
              // （1-气体残余比例）*使用量*（1-利用率）*（1-收集效率*去除效率）
              tempSum = (1 - input[1][1].value * 0.01) * input[1][0].value * (1 - 0.8) * (1 - 0.9 * 0.95)
              oneStageSum += tempSum
              let val = {
                value: tempSum,
                label: 'NF3'
              }
              oneBarChartList.push(val)
              tempSum = (1 - input[1][3].value * 0.01) * input[1][2].value * (1 - 0.8) * (1 - 0.9 * 0.9)
              oneStageSum += tempSum
              val = {
                value: tempSum,
                label: 'SF6'
              }
              oneBarChartList.push(val)
              tempSum = (1 - input[1][5].value * 0.01) * input[1][4].value * (1 - 0.1) * (1 - 0.9 * 0.9)
              oneStageSum += tempSum
              val = {
                value: tempSum,
                label: 'CF4'
              }
              oneBarChartList.push(val)
              tempSum = (1 - input[1][7].value * 0.01) * input[1][6].value * (1 - 0.4) * (1 - 0.9 * 0.9)
              oneStageSum += tempSum
              val = {
                value: tempSum,
                label: 'C2F6'
              }
              oneBarChartList.push(val)
              tempSum = (1 - input[1][9].value * 0.01) * input[1][8].value * (1 - 0.6) * (1 - 0.9 * 0.9)
              oneStageSum += tempSum
              val = {
                value: tempSum,
                label: 'C4F6'
              }
              oneBarChartList.push(val)
              let pieChartItem = {
                value: oneStageSum,
                name: pieChartTitle[1]
              }
              resList.push(pieChartItem)
              barChartList.push(oneBarChartList)
            } else {
              simpleMultiply(this.paramsInputList[this.industryNo], i, i, resList, barChartList)
            }
          }
          break
        default:
          break
      }
      let bigIndustryNo = this.bigIndustryNo
      // 把参数提交给Vue-x
      this.$store.commit('commitResData', {
        resList,
        barChartList,
        annualProValue,
        bigIndustryNo
      })
      // 判断输入参数是否为空
      if (this.isLinkIndustry === false) {
        if (this.annualOutputValue.value === '') {
          Toast('请输入年产值')
        } else {
          this.$router.push('/Report')
        }
      } else {
        Toast('请选择行业')
      }
    },
    showIndustry () {
      this.isShowIndustry = true
    },
    showAddr () {
      this.isShowAddr = true
    },
    cancel () {
      this.isShowAddr = false
      this.isShowIndustry = false
      this.isShowVideo = false
    },
    confirmIndustry (val) {
      this.from.industry = ''
      val.forEach((element) => {
        let industry = element.name
        if (this.from.industry.indexOf(industry) === -1) {
          this.from.industry = industry
          console.log(element.code)
          // code为行业编号，industryNo为行业在industryList中的下标
          this.industryNo = element.code % 100
          this.bigIndustryNo = ((element.code / 10000) - 10).toFixed(0)
        }
      })
      // 选泽行业后把弹出框和箭头取消,视频也关闭
      this.isShowIndustry = false
      this.isLinkIndustry = false
      this.isShowVideo = false
    },
    confirmAddr (val) {
      this.from.addr = ''
      val.forEach((element) => {
        if (this.from.addr.indexOf(element.name) === -1) {
          this.from.addr = this.from.addr + element.name
        }
      })
      // 选泽地区后把弹出框和箭头取消
      this.isShowAddr = false
      this.isLinkAddr = false
    }
  }
}
</script>
<style lang="scss" scoped>
.home {
  height: 100%;
  background-image: url("../assets/images/bg.png");
  background-size: 100%;
}

.main-body {
  .sub-title-img {
    width: 106px;
    height: 30px;
    line-height: 30px;
    background-image: url("../assets/images/title_bg.png");
    margin-bottom: 15px;

    span {
      margin-left: 15px;
      font-size: 16px;
      color: #ffffff;
    }
  }

  .popup-style {
    border-radius: 10px 10px 0px 0px;
  }

  .popup-group {
    margin: 15px;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.12);
    border-radius: 10px;
  }

  .input-group {
    margin: 15px;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.12);
    border-radius: 10px;
    opacity: 0.9;
  }

  .input {
    width: auto;
    border-radius: 10px;
    font-size: 14px;
    color: #666666;
  }

  .btn-block {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 24px;

    button {
      width: 100%;
      height: 40px;
      margin: 0px 15px 15px 15px;
      font-size: 18px;
      color: #ffffff;
      background-color: #2161ff;
      border-radius: 40px;
    }
  }
}

.input_video{
  width: 325px;
  height: 690px;
  margin: 0 auto;

}
</style>
